/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 1898:
/***/ (() => {

var initUpdateQuantities = function initUpdateQuantities() {
  var cartItems = document.querySelectorAll('[data-cart-item]');
  cartItems.forEach(function (cartItem) {
    var quantityActions = cartItem.querySelectorAll('[data-action="update-quantity"]');
    var lineItemKey = cartItem.getAttribute('data-line-item-key');
    var quantityInput = cartItem.querySelector("[data-quantity-input][id=\"updates_".concat(lineItemKey, "\"]"));
    var currentQuantity = Number(quantityInput.getAttribute('value'));
    var complementLineItemKey = cartItem.getAttribute('data-complement-line-item-key') || null;
    quantityActions.forEach(function (quantityAction) {
      quantityAction.addEventListener('click', function () {
        var actionType = quantityAction.getAttribute('data-action-type');
        var isRemove = actionType === 'remove';
        var isIncrease = actionType === 'plus';
        var newValue;
        if (isRemove) {
          newValue = 0;
        } else {
          newValue = isIncrease ? currentQuantity + 1 : currentQuantity - 1;
        }
        quantityInput.setAttribute('value', "".concat(newValue));
        var updates = {};
        updates[lineItemKey] = newValue;
        if (complementLineItemKey) {
          updates[complementLineItemKey] = newValue;
        }
        fetch("".concat(window.Shopify.routes.root, "cart/update.js"), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates
          })
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        }).then(function () {
          window.location.reload();
        })["catch"](function (error) {
          console.error('Error:', error);
        });
      });
    });
  });
};
initUpdateQuantities();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var _snippets_cart_items_cart_items__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1898);
/* harmony import */ var _snippets_cart_items_cart_items__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_snippets_cart_items_cart_items__WEBPACK_IMPORTED_MODULE_0__);

})();

/******/ })()
